import axios from './axios-node-instance'

export default {
  updateLandingPageData (payload, id) {
    return axios.put(`personal-trainer/landing-page/${id}`, payload)
  }
}
